import { NavLink } from "react-router-dom";
import "./MobileMenu.css";

export default function MobileMenu({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return (
    <ul
      className={`mobileMenu pb-10 bg-doctio-beige overflow-hidden ${
        open
          ? "max-h-[29rem] relative visible m-[-18px] top-[0px] p-4"
          : "max-h-0 -m-px invisible w-0"
      } w-screen text-center mt-4 left-0 flex-col md:p-0 font-medium space-y-5 md:mt-0 md:border-0 `}
    >
      <li>
        <NavLink
          to="/"
          className={(navData) =>
            navData.isActive
              ? "text-doctio-dark block text-doctio-dark  md:p-0 font-bold rounded"
              : "block text-doctio-dark font-normal  md:p-0 rounded"
          }
          aria-current="page"
        >
          Forside
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/priser"
          className={(navData) =>
            navData.isActive
              ? "text-doctio-dark block text-doctio-dark  md:p-0 font-bold rounded"
              : "block text-doctio-dark font-normal  md:p-0 rounded"
          }
        >
          Priser
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/tutorials"
          className={(navData) =>
            navData.isActive
              ? "text-doctio-dark block text-doctio-dark  md:p-0 font-bold rounded"
              : "block text-doctio-dark font-normal  md:p-0 rounded"
          }
        >
          Tutorials
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/team"
          className={(navData) =>
            navData.isActive
              ? "text-doctio-dark block text-doctio-dark  md:p-0 font-bold rounded"
              : "block text-doctio-dark font-normal  md:p-0 rounded"
          }
        >
          Teamet bag
        </NavLink>
      </li>
      <li>
        <NavLink
          to="/kontakt"
          className={(navData) =>
            navData.isActive
              ? "text-doctio-dark block text-doctio-dark  md:p-0 font-bold rounded"
              : "block text-doctio-dark font-normal  md:p-0 rounded"
          }
        >
          Kontakt
        </NavLink>
      </li>

      <li className="!mt-10">
        <NavLink
          to="/login"
          className="text-black text-dxs font-extralight tracking-wide"
        >
          LOGIN
        </NavLink>
      </li>

      <li>
        <NavLink to="/signup">
          <button
            type="button"
            className="text-white w-56 font-bold rounded-full bg-doctio-green focus:ring-4 focus:outline-none text-dbase px-4 py-2 text-center"
          >
            Opret bruger
          </button>
        </NavLink>
      </li>
    </ul>
  );
}
